import { render, staticRenderFns } from "./PartTimerDashboard.vue?vue&type=template&id=5f3f54e5"
import script from "./PartTimerDashboard.vue?vue&type=script&lang=js"
export * from "./PartTimerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports